import ShopCart from './cart.vue'

ShopCart.install = function (Vue) {
  Vue.component(ShopCart.name, ShopCart)
}

export default ShopCart
